import {Properties} from 'posthog-js'
import {createContext} from 'react'
import {IEvent, IScreen} from './Tracking.types'

export interface ITrackingContext {
  trackEvent: (eventData: IEvent) => void
  trackScreenEnter: (screenData: IScreen) => void
  trackError: (error: Error, additional?: Properties) => void
}

export const TrackingContext = createContext<ITrackingContext>({
  trackEvent: () => {
    console.warn('TrackingContext not initialized')
  },
  trackScreenEnter: () => {
    console.warn('TrackingContext not initialized')
  },
  trackError: () => {
    console.warn('TrackingContext not initialized')
  },
})
